(function () {
  const initializedKey = 'tfHeroSlideshowInitialized';

  function initHeroSlideshow(root) {
    if (!root || root.dataset[initializedKey] === 'true') return;

    const viewport = root.querySelector('.tf-hero-slideshow__viewport');
    const slides = Array.from(root.querySelectorAll('.tf-hero-slideshow__slide'));
    const prevButton = root.querySelector('.tf-hero-slideshow__arrow--prev');
    const nextButton = root.querySelector('.tf-hero-slideshow__arrow--next');
    const dots = Array.from(root.querySelectorAll('.tf-hero-slideshow__dot'));

    if (!viewport || !slides.length) return;

    root.dataset[initializedKey] = 'true';

    const autoplay = viewport.dataset.autoplay === 'true';
    const speed = Number(viewport.dataset.speed || 5) * 1000;
    let currentIndex = 0;
    let timer = null;

    function showSlide(index) {
      slides.forEach(function (slide, i) {
        const isActive = i === index;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });

      currentIndex = index;
    }

    function nextSlide() {
      const nextIndex = currentIndex + 1 >= slides.length ? 0 : currentIndex + 1;
      showSlide(nextIndex);
    }

    function prevSlide() {
      const prevIndex = currentIndex - 1 < 0 ? slides.length - 1 : currentIndex - 1;
      showSlide(prevIndex);
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function startAutoplay() {
      if (!autoplay || slides.length < 2) return;
      stopAutoplay();
      timer = setInterval(nextSlide, speed);
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        nextSlide();
        startAutoplay();
      });
    }

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        prevSlide();
        startAutoplay();
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        const index = Number(this.dataset.index);
        showSlide(index);
        startAutoplay();
      });
    });

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    showSlide(0);
    startAutoplay();

    document.addEventListener('shopify:section:unload', function (event) {
      if (root.contains(event.target)) {
        stopAutoplay();
      }
    });
  }

  function initAllHeroSlideshows(container) {
    const scope = container || document;
    const sections = scope.querySelectorAll('.tf-hero-slideshow');
    sections.forEach(initHeroSlideshow);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAllHeroSlideshows(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAllHeroSlideshows(event.target);
  });
})();